import { render } from "./DynamicComponent.vue?vue&type=template&id=5eb7320e"
import script from "./DynamicComponent.vue?vue&type=script&lang=js"
export * from "./DynamicComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__